






















































import { Component, Prop, Vue } from "vue-property-decorator";
import { ISSUE_DATE_SUGGESTION } from "./index";

@Component({
  components: {},
})
export default class IssueDateSuggestionDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop() content: string;

  onAccept() {
    this.$emit("ok", ISSUE_DATE_SUGGESTION.ACCEPT);
  }

  onNeedSupport() {
    this.$emit("ok", ISSUE_DATE_SUGGESTION.NEED_SUPPORT);
  }

  onReject() {
    this.$emit("ok", ISSUE_DATE_SUGGESTION.REJECT);
  }
}
